import { AppRouteProps } from "@harea/component"
import React from "react"

const DetailContractContainer = React.lazy(
    () => import("./container/DetailContractContainer")
)
const DetailContractAbout = React.lazy(
    () => import("./views/about/DetailContractAbout")
)
const DetailContractHistory = React.lazy(
    () => import("./views/history/DetailContractHistory")
)
const DetailContractPayment = React.lazy(
    () => import("./views/payment/DetailContractPayment")
)
const CreateAvenantContainer = React.lazy(
    () => import("views/avenant/container/CreateAvenantContainer")
)
const RenewContractContainer = React.lazy(
    () => import("./views/renew/container/RenewContractContainer")
)

export const DetailContractRoutes: Array<AppRouteProps> = [
    {
        path: "contracts/:id/details",
        title: "Harea.Contract.Details.Title",
        element: <DetailContractContainer />,
        roles: [""],
        children: [
            {
                path: "about",
                element: <DetailContractAbout />,
                index: true,
            },
            {
                path: "avenants",
                element: <DetailContractHistory />,
                children: [
                    {
                        path: "create",
                        element: <CreateAvenantContainer />,
                    },
                    {
                        path: "renew",
                        element: <RenewContractContainer />,
                    },
                ]
            },
            {
                path: "payment",
                element: <DetailContractPayment />,
            },
        ],
    },
]
